<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <!--<InfoOrder :orderType="orderType"></InfoOrder>
       <br>
       <SumOrders ref="SumOrders"></SumOrders>-->

    <div id="data-list-thumb-view" class="data-list-container">
      <vx-card title>
        <div class="mt-5">
          <div class="vx-row">
            <div class="vx-col md:w-1/5 w-1/5 mt-5">
              <h6 class="mb-2">Data Contrato</h6>
              <div>
                <datepicker
                  placeholder="Selecione a Data"
                  :language="languages['ptBR']"
                  format="dd/MM/yyyy"
                  v-model="date"
                ></datepicker>
              </div>
            </div>
            <div class="vx-col md:w-1/5 w-1/5 mt-5">
              <h6 class="mb-2">Número</h6>
              <vs-input class="w-full" v-model="number" />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-5">
              <h6 class="mb-2">Cliente</h6>
              <v-select
              name="customer"
              v-model="customerSelected"
              :options="getCustomersFiltered"
              :loading="isLoadingCustomers"
              :filterable="true"
              :searchable="true"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-validate="'required'"
              placeholder="Digite para buscar (min. 2 caracteres)..."
              @search="onSearchCustomers"
              :no-drop="searchTerm.length > 0 && searchTerm.length < 2"
              :close-on-select="true"
            >
              <template slot="no-options">
                <span v-if="searchTerm.length > 0 && searchTerm.length < 2">
                  Digite pelo menos 2 caracteres
                </span>
                <span v-else-if="isLoadingCustomers">
                  Carregando...
                </span>
                <span v-else>
                  Nenhum cliente encontrado
                </span>
              </template>
            </v-select>
              <br />
              <span class="text-danger">{{ errors.first("customer") }}</span>
            </div> 
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-5">
              <h6 class="mb-2">Tipo</h6>
              <ul class="demo-alignment">
                <li>
                  <vs-radio
                    color="warning"
                    v-model="type"
                    vs-value="Sem Contrato"
                    >Sem Contrato</vs-radio
                  >
                </li>
                <li>
                  <vs-radio
                    color="primary"
                    v-model="type"
                    vs-value="Locação"
                    >Locação</vs-radio
                  >
                </li>
                 <li> 
                  <vs-radio
                    color="success"
                    v-model="type"
                    vs-value="Ouro"
                    >Ouro</vs-radio
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="mt-5">
            <div class="vx-row">
              <div class="vx-col md:w-1/1 w-full mt-5">
                <vs-button
                  v-show="customerSelected"
                  class="float-right"
                  color="success"
                  @click="submit"
                  >Salvar</vs-button
                >
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { momentJS, numberJS } from "@/helpers";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import { baseApiUrl } from "@/global";
import router from "@/router";
import axios from "axios";
import { Validator } from "vee-validate";
const dict = {
  custom: {
    customer: {
      required: "Selecione o cliente",
    },
  },
};

Validator.localize("en", dict);
export default {
  components: { vSelect, Datepicker },
  props: {},
  data() {
    return {
      languages: lang,
      date: null,
      number: null,
      customerSelected: [],
      type: "Sem Contrato",
      searchTerm: '',
      maxResults: 50,
      minSearchLength: 2,
    };
  },
  computed: {
    // Computed otimizado - agora pega direto do state
    getCustomersFiltered() {
      return this.$store.state.customers.customersFiltered || []
    },
    
    // Novo computed para verificar loading
    isLoadingCustomers() {
      return this.$store.state.customers.isLoading
    },
  },
  methods: {
     // Método debounced para busca otimizada
     onSearchCustomers: _.debounce(async function(search) {
      this.searchTerm = search || ''
      
      try {
        await this.$store.dispatch('customers/searchCustomers', {
          searchTerm: this.searchTerm,
          limit: this.maxResults
        })
      } catch (error) {
        console.error('Erro na busca de clientes:', error)
        this.$vs.notify({
          title: 'Erro',
          text: 'Erro ao buscar clientes. Tentando busca local...',
          color: 'warning'
        })
      }
    }, 300),

    // Método para pré-carregar dados essenciais
    async preloadCustomersData() {
      try {
        const payload = {
          loading: this.$vs.loading,
          idOrder: null,
          typeOrder: this.endpointType,
          idCustomer: this.customerSelected.id,
        }
        
        // Carregar todos os clientes uma vez
        await this.$store.dispatch("customers/fetchCustomersItems", payload)
        
        // Aplicar busca inicial vazia para mostrar primeiros resultados
        await this.$store.dispatch('customers/searchCustomers', {
          searchTerm: '',
          limit: this.maxResults
        })
        
      } catch (error) {
        console.error('Erro ao pré-carregar clientes:', error)
        this.$vs.notify({
          title: 'Aviso',
          text: 'Erro ao carregar lista de clientes',
          color: 'warning'
        })
      }
    },
    async submit() {
      try {
        let data = {
          fk_idCustomer: this.customerSelected.id,
          date: this.date,
          number: this.number,
          createAt: momentJS().getDateTime(),
          type: this.type,
          fk_idUser: this.$store.state.user.idUser,
        };

        const response = await axios.post(
          `${baseApiUrl}/permanentAsset/saveContract`,
          data
        );

        this.$vs.loading.close();
        this.$vs.notify({
          title: "salvo",
          text: "Com Sucesso.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
        if (response.status == "200") {
          router.push("/contratos").catch(() => {});
        }
      } catch (error) {
        console.log(error);
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Erro",
          text: "Problema ao Salvar",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }
    },
  },
  async created() {
    this.date = momentJS().getDateTimeLocal();
    await this.preloadCustomersData()
    
    let payload = {
      loading: this.$vs.loading,
    };
       // Limpar cache expirado periodicamente
       setInterval(() => {
      this.$store.dispatch('customers/clearExpiredCache')
    }, 5 * 60 * 1000) // A cada 5 minutos

  },

  // Limpar intervalos ao destruir componente
  beforeDestroy() {
    // Limpar qualquer timer se necessário
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>
<style scoped>
/* Estilos para melhorar a performance visual */
.vs__dropdown-toggle {
  transition: border-color 0.15s ease-in-out;
}

.vs__dropdown-toggle:focus-within { 
  border-color: #3b82f6;
  box-shadow: 0 0 0 1px #3b82f6;
}

/* Otimizar scroll do dropdown */
.vs__dropdown-menu {
  max-height: 200px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* Loading state */
.vs__open-indicator {
  transition: transform 0.15s ease;
}
</style>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }
      .vs-table--search {
        padding-top: 0;
        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;
          & + i {
            left: 1rem;
          }
          &:focus + i {
            left: 1rem;
          }
        }
      }
    }
    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;
      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;
            span {
              display: flex;
              justify-content: flex-start;
            }
            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }
    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;
        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }
    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>